export const OWA_AUTO_LINKS_CLASSNAME = 'OWAAutoLink';
export const LINK_CONTEXT_MENU = 'LinkContextMenu';
export const SPAN_TAG_NAME = 'SPAN';
export const SAFELINK_ORIGINALSRC_ATTRIBUTE_NAME = 'originalsrc';
